import { InfoOutlined } from '@mui/icons-material'
import { memo } from 'react'
import { palette } from '../styles/colors'

interface InfoProps {
    color?: string
    fontSize?: 'small' | 'medium' | 'large' | 'inherit'
}

const Info = ({ color, fontSize = 'small' }: InfoProps) => (
    <InfoOutlined
        data-testid="Tooltip__PopupIcon"
        fontSize={fontSize}
        css={{ color: color ?? palette.checkboxOptionColor }}
    />
)

export default memo(Info)
